import { useEffect, useState } from "react"
import ButtonDownloadPDF from "../components/ButtonDownloadPDF"
import { DashboardLayout } from "../components/Dashboard"
import SectionTap from "../components/SectionTap"
import { SubheaderComponent } from "../components/Subheader"
import { TableGen2 } from "../components/table-gen-2"
import { ArrowDownTrayIcon, EyeIcon } from "@heroicons/react/24/outline"
import CardComponent from "../components/card"
import { TransactionResponse, TransactionUserPostDto } from "../interfaces/transaction"
import { TransactionController } from "../core/controller/transactionCtrl"
import { useNavigate, useParams } from "react-router-dom"
import { formatDate_ddMMYY, stringMin } from "../core/function/function-generic"
import LoadingComponent from "../components/loading/loading"
import { toastError } from "../core/toast/toastAlert"
import { ToastContainer, toast } from "react-toastify"
import { ResponseDTO } from "../interfaces/response"
import { kycStatus } from "../core/enum"
import ModalComponent from "../components/modal/modal"
import { HomeController } from "../core/controller/HomeCtrl"

export const TransactionDetailsPages = () => {
    const transactionController = new TransactionController()
    const homeController = new HomeController()
    const { userId } = useParams();
    const navigate = useNavigate()
    const [dataCard, setdataCard] = useState<any[]>([])
    const [datatap, setdatatap] = useState<any[]>([])
    const [optionActive, setOptionActive] = useState<string>('');
    const [nameUser, setNameUser] = useState<string>('');
    const [pagesPagination, setpagesPagination] = useState(1);
    const [isLoading, setisLoading] = useState<boolean>(false)
    const [open, setOpen] = useState<boolean>(false);
    const [statusKyc, setStatusKyc] = useState<boolean | null>(null)
    const [valuePeriod, setValuePeriod] = useState<string>('')
    const [action, setAction] = useState<string>('')
    const [valueSearch, setValueSearch] = useState<string | null>(null)
    const [valueStatus, setValueStatus] = useState<string | null>(null)
    const [dataOperation, setdataOperation] = useState<any>();
    const [timeoutId, setTimeoutId] = useState<any>(0);
    const [dataTable, setDataTable] = useState({
        divContent: 'table-info w-[82%] sm:w-[82%] md:w-full lg:w-full xl:w-full h-[60vh]',
        classTable: 'w-full min-w-max table-auto',
        columns: [
            {
                nameColumn: "Transaction ID",
                keysColumns: 'txid',
                classThHead: 'text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold  bg-[#f9fafb]',
                classStyles: 'py-6 text-center text-[#475467] text-[14px] not-italic font-[Inter] font-normal leading-5'
            },
            {
                nameColumn: "Date",
                keysColumns: 'date',
                classThHead: 'text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold  bg-[#f9fafb]',
                classStyles: 'py-6 text-center text-[#475467] text-[16px] not-italic font-[Montserrat] font-semibold leading-5'
            },
            {
                nameColumn: "Amount",
                keysColumns: 'amount',
                classThHead: `text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold  bg-[#f9fafb]`,
                classStyles: 'py-6 text-center text-[#475467] text-[16px] not-italic font-[Montserrat] font-semibold leading-5'
            },
            {
                nameColumn: "Country",
                keysColumns: 'country',
                classThHead: 'text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold  bg-[#f9fafb]',
                classStyles: 'py-6 text-center text-[#475467] text-[16px] not-italic font-[Montserrat] font-semibold leading-5'
            },
            {
                nameColumn: "Method",
                keysColumns: 'paymentmethod',
                classThHead: 'text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold  bg-[#f9fafb]',
                classStyles: 'py-6 text-center text-[#475467] text-[16px] not-italic font-[Montserrat] font-semibold leading-5'
            },
            {
                nameColumn: "Status",
                keysColumns: 'tx_status',
                classThHead: 'text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold  bg-[#f9fafb]',
                classStyles: 'py-6 w-full flex justify-center text-[#475467] text-[16px] not-italic font-[Montserrat] font-semibold leading-5'
            },
        ],
        data: [],
        classTrBody: 'bord-th-body-table',
        totalPages: 0,
        isAction: true,
        actionIcon: [
            { icon: <ArrowDownTrayIcon className='w-[1.5rem] color-Logout cursor-pointer' />, action: 'download' },
            { icon: <EyeIcon className='w-[1.5rem] color-Logout cursor-pointer' />, action: 'view' }
        ],
        iconClass: `border-fff`
    });

    useEffect(() => {
        setdatatap([{
            name: 'Transaction History',
            class: 'w-full p-4' +
                'text-[#0000] font-[Montserrat] leading-[27px]' +
                ' not-italic font-bold text-[17px] text-center pb-2.5'
        }])
        setValuePeriod('24 hours')
        setOptionActive('Transaction History')
        setdataCard([{
            title: 'Total Volume',
            amount: '$0',
            totalPercent: '+10%',
            nameUser: 'N/A'
        }])

        getTransactionsByUserId(Number(userId), null, '24 hours', null, 'ASC', 1, 10)
    }, [])

    const getTransactionsByUserId = async (
        idUser: number,
        search: string | null = null,
        period: string,
        status: string | null = null,
        order = 'ASC',
        page: number,
        take: number,
    ) => {

        setisLoading(true)
        const requestBody: TransactionUserPostDto = {
            idUser, search, period, status, order, page, take
        }

        const response: ResponseDTO | any = await transactionController.getTransactionsByUserId(requestBody)

        if (response.statusCode >= 400) {
            setisLoading(false)
            toast.error(response.message, toastError)
            return
        }

        if (response.data.statusCode >= 400) {
            setisLoading(false)
            toast.error(response.data.message, toastError)
            return
        }

        if (response.data.statusCode === 200) {
            const resultData: any = response.data.data.result.map((res: TransactionResponse) => ({
                ...res,
                date: formatDate_ddMMYY(res.date),
                status: res.tx_status,
                tx_status: (
                    <div className={`w-[7.5rem] cursor-default badge bg-color-${res.tx_status?.toLowerCase()}`}>
                        <span className={`fontPageTitle600`}>{stringMin(res.tx_status)}</span>
                    </div>
                )
            }))

            setStatusKyc(response.data.data.statuskyc)
            setNameUser(response.data.data.user)

            setdataCard([{
                title: 'Total Volume',
                amount: `$${response.data.data.amountTotal || 0}`,
                totalPercent: '+10%',
            }])

            setDataTable((prevProps) => ({
                ...prevProps,
                data: resultData,
                totalPages: response.data.data.totalPages
            }))

            setisLoading(false)
        }
    }

    const onsearchFilter = (nameTap: string) => {
        setOptionActive(nameTap)
    };

    const handleNextPageClick = async (e: any) => {
        setpagesPagination((e.selected + 1));
        await getTransactionsByUserId(Number(userId), valueSearch, valuePeriod, valueStatus, 'ASC', (e.selected + 1), 10)
    }

    const onAction = async (event: any) => {
        if (['view', 'download'].includes(event.action)) {
            setAction(event.action)
            const response = await getTransactionRetriveCmsById(event.data.txid)
            console.log(response)
            setdataOperation({ ...event.data, ...response });
            setOpen(true)
        }
    }
    const getTransactionRetriveCmsById = async (transactionId: string) => {
        try {
            const response: ResponseDTO | any = await homeController.getTransactionRetriveCmsById(transactionId)
            if (response.statusCode >= 400) {
                setisLoading(false)
                toast.error(response.message, toastError)
                return
            }

            if (response.data.statusCode >= 400) {
                setisLoading(false)
                toast.error(response.data.message, toastError)
                return
            }

            return response.data.data

        } catch (error: any) {
            if (error.response.data.message.includes('null')) {
                toast.info('The transaction has not been approved', toastError)
            } else {
                toast.error(error.response.data.message, toastError)
            }
        }
    }

    const onFilter = async (nameFilter: string, valueFilter: string) => {
        if (nameFilter === 'period') {
            setValuePeriod(valueFilter)
            await getTransactionsByUserId(Number(userId), valueSearch, valueFilter, valueStatus, 'ASC', pagesPagination, 10)
            return
        }

        if (nameFilter === 'status') {
            setValueStatus(valueFilter)
            await getTransactionsByUserId(Number(userId), valueSearch, valuePeriod, valueFilter, 'ASC', pagesPagination, 10)
            return
        }

        if (nameFilter === 'search') {
            clearTimeout(timeoutId);
            setTimeoutId(
                setTimeout(async () => {
                    await getTransactionsByUserId(Number(userId), valueFilter, valuePeriod, valueStatus, 'ASC', pagesPagination, 10)
                }, 2000)
            );

            setTimeout(() => {
                clearTimeout(timeoutId);
            }, 2000);
            setValueSearch(valueFilter)
            return
        }
    }

    const closeModal = () => {
        setOpen(false);
    }

    const handleDownload = () => { }

    return (
        <>
            <LoadingComponent isOpen={isLoading} />
            <DashboardLayout pageTitle={'User Transaction Details'} onExportFile={handleDownload}>
                <ModalComponent isOpen={open} closeModal={closeModal} withWindows='800px'>
                    <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                        <p className={`text-20-700`}>
                            Transaction Information
                        </p>
                        <button
                            className="p-1 ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                            onClick={() => closeModal()}
                        >
                            <span className="text-black h-6 w-6 text-2xl block outline-none">
                                ×
                            </span>
                        </button>
                    </div>
                    <div>
                        <div className="grid grid-cols-2 w-full p-transaction">
                            <div className="col-span-1">
                                <p className="text-16">Transaction Details</p>
                            </div>
                            <div className="flex justify-start">
                                <div className="text-end">
                                    <div className="flex flex-wrap mb-2 text-14 w-full  mr-4">
                                        <div><span className="mr-[10px]">Status</span></div>
                                        <div className={`w-[7.5rem] cursor-default badge bg-color-${dataOperation?.status?.toLowerCase()}`}>
                                            <span className={`fontPageTitle600`}>{stringMin(dataOperation?.status)}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="mr-[10px]">
                                    <label className="flex mb-2 text-14 w-full  mr-[10px]">
                                        <div><span className="mr-[10px]">KYC</span></div>
                                        <div className="w-full fontPageTitle600 badge bg-color-approved text-max-center">
                                            <span className={`fontPageTitle600`}>
                                                {dataOperation?.kyc ? 'Verified' : 'Not Verified'}
                                            </span>
                                        </div>
                                    </label>
                                </div>
                                <div></div>
                            </div>
                        </div>
                        <div className="grid gap-6 m-[20px] md:grid-cols-3 ">
                            <div>
                                <label className="block mb-2 text-14-500">Method</label>
                                <div className="text-14-111312-700">
                                    {(dataOperation?.paymentmethod) ? dataOperation?.paymentmethod : 'N/A'}
                                </div>
                            </div>
                            <div>
                                <label className="block mb-2 text-14-500">Amount</label>
                                <div className="text-14-111312-700">
                                    {(dataOperation?.amount) ? dataOperation?.amount : ''}
                                </div>
                            </div>
                            <div></div>
                            <div className="">
                                <label className="block mb-2 text-14-500">Country</label>
                                <div className="text-14-111312-700">
                                    {dataOperation?.country} <span className="fontPageTitle600">{dataOperation?.countryName}</span>
                                </div>
                            </div>
                            <div className="">
                                <label className="block mb-2 text-14-500">From</label>
                                <div className="text-14-111312-700">
                                    <span className="fontPageTitle600">{(dataOperation?.detailFrom) ? dataOperation?.detailFrom : 'N/A'}</span>
                                </div>
                            </div>
                            <div>
                                <label className="block mb-2 text-14-500">To</label>
                                <div className="text-14-111312-700">
                                    <span className="fontPageTitle600">{(dataOperation?.detailTo) ? dataOperation?.detailTo : 'N/A'}</span>
                                </div>
                            </div>
                        </div>
                        <div className="grid gap-6 m-[20px]">
                            <p className="text-17-700">User Details</p>
                        </div>
                        <div className="grid gap-6 grid-cols-3 m-[20px]">
                            <div>
                                <label className="block mb-2 text-14-500">Name</label>
                                <div className="text-14-111312-700">
                                    {(dataOperation?.fullname) ? dataOperation?.fullname : ''}
                                </div>
                            </div>
                            <div>
                                <label className="block mb-2 text-14-500">Phone number</label>
                                <div className="text-14-111312-700">
                                    {(dataOperation?.phone) ? dataOperation?.phone : 'N/A'}
                                </div>
                            </div>
                            <div></div>
                            <div className="">
                                <label className="block mb-2 text-14-500">Email</label>
                                <div className="text-14-111312-700">
                                    {(dataOperation?.email) ? dataOperation?.email : 'N/A'}
                                </div>
                            </div>
                        </div>
                        <div className={`w-auto flex gap-6 m-[10px] mb-[40px] ${['download'].includes(action) ? 'justify-between' : ''}`}>
                            <div className="sm:w-full md:w-[10%]">
                                <label className="block mb-[11px] ml-[10px] text-12"> Date </label>
                                <p className="ml-[10px] text-14-400-000">{dataOperation?.date}</p>
                            </div>
                            <div className="sm:w-full md:w-[50%]">
                                <label className="block mb-2 ml-[10px] text-12">Transaction ID</label>
                                <div className="ml-[10px] text-16">{dataOperation?.txid}</div>
                            </div>
                            {
                                ['download'].includes(action) && (
                                    <div className="self-center">
                                        <ButtonDownloadPDF />
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </ModalComponent>
                <main className='mt-6'>
                    <div className='text-[14px] font-bold flex flex-wrap flex-auto justify-between items-baseline w-full h-full'>
                        <div className='flex justify-center' onClick={() => navigate('/withdrawal')}>
                            <button>
                                <svg className='w-[17px] h-[17px]' viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.9014 8.4707H1.90137M1.90137 8.4707L8.90137 15.4707M1.90137 8.4707L8.90137 1.4707" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <h1 className='text-[24px] font-bold m-2'>{nameUser || 'N/A'}</h1>
                        </div>
                        <div className='flex mb-10'>
                            <div className='flex items-center mr-2'>
                                <span className='mr-2'>Status:</span>
                                <div className={`w-[7.5rem] cursor-default rounded-md p-2 text-center ${kycStatus[String(statusKyc)][3]} border-2`}>
                                    <span className={`w-full fontPageTitle600 ${kycStatus[String(statusKyc)][2]}`}>{kycStatus[String(statusKyc)][0]}</span>
                                </div>
                            </div>
                            <div className='flex items-center'>
                                <ButtonDownloadPDF />
                            </div>
                        </div>
                    </div>
                    <div className='w-full flex justify-between mb-10'>
                        <div>
                            <SectionTap onsearchFilter={onsearchFilter} datatap={datatap} optionActive={optionActive} />
                        </div>
                    </div>
                    <div className="w-full mb-8">
                        <CardComponent CardDataOption={dataCard} classNames={'grid md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-4'} />
                    </div>
                    <SubheaderComponent name='Transactions' onFilters={onFilter} dataOption="in" />
                    <div className="mb-12">
                        <TableGen2
                            dataTableGen={dataTable}
                            handleNextPageClick={handleNextPageClick}
                            onAction={onAction} />
                    </div>
                </main>
                <ToastContainer />
            </DashboardLayout>
        </>
    )
}